<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {useTicketStore} from "../../../store/tickets"
import {useModalStore} from "../../../store/modal"
import {useUserStore} from "../../../store/users"
import {useAuthStore} from "../../../store/auth"
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";

const options = []
const loading = ref(false)
const route = useRoute()
const ticketStore = useTicketStore()
const modalStore = useModalStore()
const userStore = useUserStore()
const is_assigned = ref(false)
const reload = computed(() => is_assigned.value && route.name !== 'tickets-single')
const heading = computed(() => {
    if (is_assigned.value) {
        return `Ticket assigned.`
    } else {
        return ticketStore.ticket?.assignee_id ?  `Reassign ticket.` : `Assign ticket.`
    }
})
const description = computed(() =>
    is_assigned.value
        ? users.value.find(u => u.id === assigned_user.value).first_name
        : ticketStore.ticket?.assignee
    ? `Assigned to ${ticketStore.ticket.assignee.first_name}`
    : null
)
const users = ref([])
const assigned_user = ref()
const authStore = useAuthStore()
const isAdmin = computed(() => ['reseller-super-admin', 'reseller-team-leader', 'super-admin', 'internal-super-admin', 'internal-team-leader'].includes(authStore.user.roles[0].name))

const assignTicket = async () => {
    loading.value = true
    await ticketStore.assignTicket(modalStore.props.id, assigned_user.value)
    loading.value = false
    is_assigned.value = true
}

onMounted(async () => {
    loading.value = true
    await ticketStore.getTicket(modalStore.props.id)
    loading.value = false
    await userStore.getAllUsers({all: false, role: 'internal-agent'});
    users.value = isAdmin.value ? userStore.users : [authStore.user]

    users.value.forEach(u => {
        options.push({
            value: u.id,
            label: `${u.first_name} ${u.last_name}`
        })
    })
})
</script>

<template>
<DefaultModalBase :description  :heading :icon="is_assigned ? 'check-all' : ticketStore.ticket?.assignee ? 'arrow-rotate' : 'user-single-add'" :loading :refresh="reload">

    <div class="ticket-assign-container">
        <brand-button variant="secondary" v-if="is_assigned" @click="modalStore.close(reload)">Done</brand-button>
        <brand-form-select :label="ticketStore.ticket?.assignee ?'Reassign to.' : 'Assign to.'" :options="options" v-model="assigned_user" v-if="!is_assigned"/>
        <brand-button @click="assignTicket()" :disabled="!assigned_user" v-if="!is_assigned">{{ticketStore.ticket?.assignee ? "Reassign ticket" : "Assign ticket"}}</brand-button>
    </div>
</DefaultModalBase>
</template>

<style scoped lang="scss">
.ticket-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
